import { createApp, defineAsyncComponent } from 'vue';
import emitter from '../plugins/emitter';

const app = createApp({
    components: {
        VueComments: defineAsyncComponent(() => import('../components/content/Comments.vue')),
        VueShare: defineAsyncComponent(() => import('./Share.vue')),
    },
});

app.use(emitter);
app.mount('#vue__training__details');